var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"rec"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getRecommendCode}},[_vm._v("实时获取注册码")]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.recommendCode))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dc3a25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/recommend.vue
// module id = null
// module chunks = 